import type { Options } from "@popperjs/core";

/**
 * Escape scroll/overflow ancestors (e.g. .content, org cards).
 * Do not pass `modifiers` here — spreading them replaces Bootstrap's
 * offset/computeStyles and parks the menu at the viewport origin.
 */
export const dropdownPopperConfig: Partial<Options> = {
  strategy: "fixed",
};
